import * as React from "react";
import { matchPath, Route, Routes, useLocation, useNavigate } from "react-router";
import NavigationHelper from "../../utils/NavigationHelper";
import { userHasAccess } from "../../utils/UserHelper";
import UnauthorizedView from "../../user/UnauthorizedView";
import {
    getUserInformation,
} from "../../../state/action";
import { RootState } from "../../../state";
import { login } from "../../../state/user/action";
import { Dispatch, Action } from "redux";
import { connect } from "react-redux";


export interface AuthRouteProps {
    allowedUserRoles: UserRole[];
    component: React.ComponentType<any>;
    path: string | string[];
    exact?: boolean;
}

// Every AuthRoute matches on its own, so several can render for one URL (e.g. a page and the footer).
// Without "exact" a path also matches everything below it.
const AuthRoute: React.FunctionComponent<StateProps & AuthRouteProps> = props => {
    NavigationHelper.setNavigate(useNavigate());

    const { pathname } = useLocation();
    const patterns = (Array.isArray(props.path) ? props.path : [props.path]).map(path =>
        props.exact ? path : `${path.replace(/\/$/, "")}/*`
    );
    // A <Routes> without a match logs a warning, and most AuthRoutes don't match a given URL
    if (!patterns.some(pattern => matchPath(pattern, pathname))) {
        return null;
    }

    const Component = props.component;
    const element = userHasAccess(props.userInformation.roles, props.allowedUserRoles)
        ? <Component />
        : <UnauthorizedView login={props.login} />;

    return (
        <Routes>
            {patterns.map(pattern => (
                <Route key={pattern} path={pattern} element={element} />
            ))}
        </Routes>
    );
};

const mapStateToProps = (state: RootState) => {
    return {
        userInformation: getUserInformation(state),
    };
};

const mapToDispatchProps = (dispatch: Dispatch<Action>) => ({
    login: (userName: string, password: string) =>
        dispatch<any>(login(userName, password)),

});

type StateProps = ReturnType<typeof mapStateToProps> &
    ReturnType<typeof mapToDispatchProps>;

export default connect(
    mapStateToProps,
    mapToDispatchProps
)(AuthRoute);
